import React from 'react';
import Dialog from '../components/ui/Dialog';
import { Button } from '../components/ui/button';

const Modal = ({ isOpen, onClose, onConfirm, title, message, confirmText = 'Confirm', cancelText = 'Cancel' }) => {
  if (!isOpen) return null;

  return (
    <Dialog isOpen={isOpen} onClose={onClose} title={title}>
        <p className="m-0 leading-relaxed">{message}</p>
        <div className="mt-6 flex flex-wrap justify-end gap-3">
          <Button type="button" variant="neutral" size="action" className="m-0 border-solid" onClick={onClose}>
            {cancelText}
          </Button>
          <Button type="button" variant="brand" size="action" className="m-0" onClick={onConfirm}>
            {confirmText}
          </Button>
        </div>
    </Dialog>
  );
};

export default Modal;
